// extracted by mini-css-extract-plugin
export default {"container":"styles_container__b1KkD","image":"styles_image__p2hM-"};